import { useEffect, useState } from "react";
import { getAnnouncement, RemoveAnnounceMent } from "../../services/dataService";
import { IMAGE_URL } from "../../services/apiGateway";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { getSecureItem } from "../../services/SecureStorage";
const UID = getSecureItem('userId')
const Announcements = () => {
    const [allAnnouncements, setAllAnnouncements] = useState([]); // Store all announcements
    const [filteredAnnouncements, setFilteredAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const isAdmin = getSecureItem("IsAdmin");

    const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
    const Dep = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
    // Date filter states
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [isFiltering, setIsFiltering] = useState(false);

    // Search filter state
    const [searchTerm, setSearchTerm] = useState("");

    const fetchAnnouncements = async () => {
        setLoading(true);
        try {
            const data = {
                UserId: UID
            };
            const response = await getAnnouncement(data);

            // Store all announcements (no backend filtering)
            const fetchedData = response.data.data;
            console.log(fetchedData, 'fetched announcements');

            // If admin, filter announcements where any employee matches the department
            const details = isAdmin == 0
                ? fetchedData.filter(item =>
                    item.Employees.some(emp => emp.DepartmentID == Dep)
                )
                : fetchedData;

            setAllAnnouncements(details);
            setFilteredAnnouncements(details);
        } catch (error) {
            console.error("Error fetching announcements:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAnnouncements();
    }, [UID]);

    // Apply combined filters (search + date)
    useEffect(() => {
        let filtered = allAnnouncements;

        // Apply date filter first
        if (fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            // Set time to end of day for 'to' date to include full day
            to.setHours(23, 59, 59, 999);

            filtered = filtered.filter(announcement => {
                const announcementDate = new Date(announcement.Systime);
                return announcementDate >= from && announcementDate <= to;
            });
        }

        // Apply search filter
        if (searchTerm.trim() !== "") {
            filtered = filtered.filter(announcement =>
                announcement.Heading.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        setFilteredAnnouncements(filtered);
    }, [searchTerm, allAnnouncements, fromDate, toDate]);

    const handleDateFilter = () => {
        if (!fromDate || !toDate) {
            alert("Please select both From Date and To Date");
            return;
        }

        if (new Date(fromDate) > new Date(toDate)) {
            alert("From Date cannot be greater than To Date");
            return;
        }

        // The filtering will be handled by the useEffect
        // This button just validates the dates
        // The actual filtering happens in the useEffect when fromDate/toDate change
    };

    const handleClearFilter = () => {
        setFromDate("");
        setToDate("");
        setSearchTerm("");
        // No need to refetch - the useEffect will handle the filtering
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleViewDetails = (announcement) => {
        setSelectedAnnouncement(announcement);
        setShowModal(true);
    };


    // Import your API service function, assuming it's named like this:
    // import { apiRemoveAnnouncement } from 'your-api-service-path';
    const handleRemoveAnnouncement = async (Id) => {
        if (Id) {
            try {
                const data = { UserId: UID, Id };
                console.log(data, 'Payload to delete');

                const response = await RemoveAnnounceMent(data); // ✅ now it's correct
                if (response.status === 200) {
                    toast.success("Announcement removed successfully.");
                    await fetchAnnouncements(); // Refresh list
                }
            } catch (error) {
                console.error("Error removing announcement:", error);
                toast.error("Failed to remove announcement.");
            }
        }
    };





    const closeModal = () => {
        setShowModal(false);
        setSelectedAnnouncement(null);
    };

    const toggleDescription = (announcementId) => {
        setExpandedDescriptions(prev => ({
            ...prev,
            [announcementId]: !prev[announcementId]
        }));
    };

    // Function to handle document opening
    const handleDocumentClick = (document) => {
        const documentUrl = `${IMAGE_URL}/${document}`;
        window.open(documentUrl, '_blank');
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getViewStatusColor = (status) => {
        return status === "1" ? "text-green-600" : "text-red-600";
    };

    const getViewStatusText = (status) => {
        return status === "1" ? "Viewed" : "Not Viewed";
    };

    const getViewStatusBg = (status) => {
        return status === "1" ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200";
    };

    const truncateDescription = (description, maxLength = 200) => {
        if (description.length <= maxLength) return description;
        return description.substring(0, maxLength);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-full mx-auto px-4 py-8">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    {/* Header */}
                    <div className="bg-white border-b border-gray-200 shadow-sm px-6 py-4">
                        <div className="flex flex-wrap lg:flex-nowrap items-center justify-between gap-4">

                            {/* Title Section */}
                            <div className="flex items-center gap-3 min-w-[250px]">
                                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white text-lg font-bold">
                                    CA
                                </div>
                                <div>
                                    <h1 className="text-lg font-semibold text-gray-900">Company Announcements</h1>
                                    <p className="text-sm text-gray-500">Stay updated with the latest news</p>
                                </div>
                            </div>

                            {/* Search Input */}
                            <div className="w-full lg:w-[300px]">
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder="Search announcements..."
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                />
                            </div>

                            {/* Date Range Filter */}
                            <div className="flex items-center gap-2 text-sm">
                                <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                />
                                <span className="text-gray-500">to</span>
                                <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                />
                                <button
                                    onClick={handleClearFilter}
                                    className="btn btn-danger"
                                >
                                    Clear Filters
                                </button>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex items-center gap-2">


                            </div>

                            <div className="flex items-center gap-2">

                                <Link to={'/Announcement'}>   <button

                                    className="btn btn-danger"
                                >
                                    Go Back
                                </button></Link>
                            </div>

                            {/* View All Button */}


                        </div>
                    </div>



                    {loading ? (
                        <div className="flex justify-center items-center h-64">
                            <div className="relative">
                                <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200"></div>
                                <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent absolute top-0"></div>
                            </div>
                        </div>
                    ) : filteredAnnouncements.length === 0 ? (
                        <div className="text-center py-20">
                            <div className="text-6xl mb-4">📭</div>
                            <p className="text-gray-500 text-xl">No announcements found.</p>
                            <p className="text-gray-400 mt-2">
                                {searchTerm || (fromDate && toDate) ?
                                    'Try adjusting your search criteria or clear the filters.' :
                                    'Check back later for updates!'
                                }
                            </p>
                        </div>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="bg-gray-100 border-b-2 border-gray-200">
                                        <th className="text-left p-4 font-semibold text-gray-700 w-16">SN</th>
                                        <th className="text-left p-4 font-semibold text-gray-700 w-48">Heading</th>
                                        <th className="text-left p-4 font-semibold text-gray-700">Description</th>
                                        <th className="text-left p-4 font-semibold text-gray-700 w-32">Date</th>
                                        <th className="text-left p-4 font-semibold text-gray-700 w-24">Docs</th>
                                        <th className="text-left p-4 font-semibold text-gray-700 w-24">Staff</th>
                                        <th className="text-left p-4 font-semibold text-gray-700 w-32">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredAnnouncements.map((item, index) => (
                                        <tr key={item.AnnouncementId} className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150">
                                            <td className="p-4 font-medium text-gray-900 font-medium text-[20px]">
                                                {index + 1}
                                            </td>
                                            <td className="p-4">
                                                <div className="font-semibold font-medium text-[20px] text-gray-900 mb-1">
                                                    {item.Heading}
                                                </div>
                                            </td>
                                            <td className="p-4">
                                                <div className="text-gray-700 font-medium text-[20px] leading-relaxed">
                                                    {expandedDescriptions[item.AnnouncementId] || item.Description.length <= 200
                                                        ? item.Description
                                                        : truncateDescription(item.Description)
                                                    }
                                                    {item.Description.length > 200 && (
                                                        <button
                                                            onClick={() => toggleDescription(item.AnnouncementId)}
                                                            className="text-blue-600 hover:text-blue-800 font-medium ml-2 transition-colors fs-14px"
                                                        >
                                                            {expandedDescriptions[item.AnnouncementId] ? "Show less" : "Read more..."}
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="p-4 fs-14px text-gray-600">
                                                {formatDate(item.Systime)}
                                            </td>
                                            <td className="p-4 text-center">
                                                <div className="inline-flex items-center justify-center w-8 h-8 font-medium text-[20px]">
                                                    {item.Documents?.length || 0}
                                                </div>
                                            </td>
                                            <td className="p-4 text-center">
                                                <div className="inline-flex font-medium text-[20px] items-center justify-center w-8 h-8 bg-purple-100 text-purple-600 rounded-full font-medium fs-14px">
                                                    {item.Employees?.length || 0}
                                                </div>
                                            </td>
                                            <td className="p-4">
                                                <div className="flex flex-row gap-2">
                                                    <button
                                                        onClick={() => handleViewDetails(item)}
                                                        className="bg-blue hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium shadow"
                                                    >
                                                        View Details
                                                    </button>
                                                    <button
                                                        onClick={() => handleRemoveAnnouncement(item.AnnouncementId)}
                                                        className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium shadow"
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Enhanced Modal */}
                {showModal && selectedAnnouncement && (
                    <div className="fixed inset-0  bg-opacity-60 flex items-center justify-center z-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl w-full max-w-6xl max-h-[90vh] overflow-hidden mx-4 shadow-2xl">
                            {/* Modal Header */}
                            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <h2 className="text-2xl font-bold mb-1 text-white">
                                            {selectedAnnouncement.Heading}
                                        </h2>
                                        <p className="text-blue-100">Employee Status & Document Details</p>
                                    </div>
                                </div>
                            </div>

                            <div className="p-6 overflow-y-auto max-h-[70vh]">
                                {/* Documents Section - Now Clickable */}
                                {selectedAnnouncement.Documents && selectedAnnouncement.Documents.length > 0 && (
                                    <div className="mb-6">
                                        <h3 className="text-xl font-bold text-gray-800 mb-4">📄 Documents</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                            {selectedAnnouncement.Documents.map((doc, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => handleDocumentClick(doc.DocumentId)}
                                                    className="bg-blue-50 border border-blue-200 rounded-lg p-3 cursor-pointer hover:bg-blue-100 hover:border-blue-300 transition-all duration-200 hover:shadow-md transform hover:-translate-y-0.5"
                                                >
                                                    <div className="flex items-center">
                                                        <span className="text-blue-600 mr-2">📎</span>
                                                        <span className="fs-14px font-medium text-blue-700 truncate hover:text-blue-900">
                                                            {doc.DocumentId}
                                                        </span>
                                                    </div>
                                                    <div className="text-xs text-blue-500 mt-1 opacity-70">
                                                        Click to open
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Employee Status Section */}
                                <div className="mb-6">
                                    <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-xl font-bold text-gray-800">👥 Employee Status</h3>
                                        <div className="flex gap-4">
                                            <div className="flex items-center">
                                                <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                                                <span className="fs-14px text-gray-600">
                                                    Viewed: {selectedAnnouncement.Employees?.filter(emp => emp.ViewStatus === "1").length || 0}
                                                </span>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
                                                <span className="fs-14px text-gray-600">
                                                    Not Viewed: {selectedAnnouncement.Employees?.filter(emp => emp.ViewStatus === "0").length || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {selectedAnnouncement.Employees && selectedAnnouncement.Employees.length > 0 ? (
                                        <div className="overflow-x-auto">
                                            <table className="w-full border border-gray-200 rounded-lg">
                                                <thead>
                                                    <tr className="bg-gray-100">
                                                        <th className="text-left p-3 font-semibold text-gray-700">Employee Name</th>
                                                        <th className="text-left p-3 font-semibold text-gray-700">Code</th>
                                                        <th className="text-left p-3 font-semibold text-gray-700">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedAnnouncement.Employees.map((emp, index) => (
                                                        <tr key={emp.EmpId} className={`border-b ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                                                            <td className="p-3 font-medium text-gray-900">{emp.Name}</td>
                                                            <td className="p-3 text-gray-600">{emp.Code}</td>
                                                            <td className="p-3">
                                                                <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getViewStatusBg(emp.ViewStatus)} ${getViewStatusColor(emp.ViewStatus)}`}>
                                                                    {emp.ViewStatus === "1" ? "✅" : "❌"} {getViewStatusText(emp.ViewStatus)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center py-12">
                                            <div className="text-6xl mb-4">👥</div>
                                            <p className="text-gray-500 text-lg">No employees assigned to this announcement.</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="bg-gray-50 border-t border-gray-200 p-4">
                                <div className="flex justify-end">
                                    <button
                                        onClick={closeModal}
                                        className="bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white px-6 py-2 rounded-lg transition-all duration-200 font-medium shadow-md hover:shadow-lg"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Announcements;